<div class="header">
    <div class="flex-row align-center wrappable" style="gap: .25em;">
        @if (view === 'month') {
            <label class="input filled" [title]="'MONTH' | trans" style="min-width: 7em; max-width: 7em">
                <select [(ngModel)]="selectedMonth" (ngModelChange)="onChangeDate()">
                    <option *ngFor="let month of months; let i = index" [ngValue]="i">{{ month }}</option>
                </select>
            </label>
            <label class="input filled" [title]="'YEAR' | trans">
                <input [(ngModel)]="selectedYear" (ngModelChange)="onChangeDate()" style="width: 3em;" type="number" integer />
            </label>
        } @else {
            <span class="shelf-range-label">{{ view === 'week' ? week_range_label() : day_label() }}</span>
        }
        <button class="round filled" color="secondary" (click)="nav(-1)"><i icon="chevron_left"></i></button>
        <button class="round filled" color="secondary" (click)="nav(1)"><i icon="chevron_right"></i></button>

        <div class="shelf-view-toggle flex-row" style="margin-left: .5em;">
            <button [class.active]="view === 'month'" (click)="set_view('month')">{{ 'PUNJENJE.VIEW.MONTH' | trans }}</button>
            <button [class.active]="view === 'week'" (click)="set_view('week')">{{ 'PUNJENJE.VIEW.WEEK' | trans }}</button>
            <button [class.active]="view === 'day'" (click)="set_view('day')">{{ 'PUNJENJE.VIEW.DAY' | trans }}</button>
        </div>
    </div>

    @if (can_add) {
        <div class="temp-add-button" style="flex: 0 0 100%; width: 100%;">
            <button class="filled pill" color="primary" (click)="new_plan()">
                <i icon="add_circle"></i>
                <span>{{ 'PUNJENJE.NEW_PLAN' | trans }}</span>
            </button>
        </div>
    }

    <div class="flex-wrap calendar-filters-wrapper flex-row wrappable align-center" style="flex: 0 0 100%">
        @if (!is_supplier) {
            <knw-auto-search
                [function]="search_suppliers"
                [to-label]="format_supplier_name"
                [allow-null]="true"
                [popover-width]="'auto'"
                [(ngModel)]="selectedSuppliers" [multi]="true"
                (ngModelChange)="getData()"
                label="{{ 'PUNJENJE.FILTER.SUPPLIER' | trans }}"
                [classes]="'filled'">
            </knw-auto-search>
        }

        <knw-auto-search
            [function]="search_locations"
            [to-label]="format_location_name"
            [allow-null]="true"
            [popover-width]="'auto'"
            [(ngModel)]="selectedLocations" [multi]="true"
            (ngModelChange)="getData()"
            label="{{ 'PUNJENJE.FILTER.STORE' | trans }}"
            [classes]="'filled'">
        </knw-auto-search>

        <knw-auto-search
            [function]="search_visit_types"
            [to-label]="format_visit_type"
            [allow-null]="true"
            [multi]="true"
            [no-search]="true"
            [popover-width]="'auto'"
            [(ngModel)]="selectedTypes"
            (ngModelChange)="refresh()"
            label="{{ 'PUNJENJE.FILTER.TYPE' | trans }}"
            [classes]="'filled'">
        </knw-auto-search>

        <div class="flex-row align-center wrappable shelf-legend">
            <ng-container *ngFor="let l of legend">
                <div (click)="filterStatus(l)" class="flex-row align-center legend-chip">
                    <i [attr.icon]="l.icon" [ngStyle]="{color: l.selected ? l.color : 'gray'}"></i>&nbsp;<span>{{ l.trans | trans }}</span>
                </div>
            </ng-container>
        </div>

        <div class="flex-row align-center" style="margin-left: auto; gap: .25em;">
            @if (can_export) {
                <button class="round filled" color="secondary" (click)="export_xlsx()" [title]="'PUNJENJE.EXPORT' | trans">
                    <i icon="download"></i>
                </button>
            }
            <button class="round" [title]="'PUNJENJE.FILTER.CLEAR' | trans" (click)="clear_filter()">
                <i icon="clear"></i>
            </button>
        </div>
    </div>
</div>

<div class="body">
    <div class="blind" [ngClass]="{ open: !('load-shelf' | inProgress) }">
        <knw-spinner color="primary" size="100"></knw-spinner>
    </div>

    @switch (view) {
        @case ('week') {
            <div class="date-grid shelf-week counter">
                <ng-container *ngFor="let wd of week_days()">
                    <div class="day this-month" [class.today]="is_today_date(wd)">
                        <span class="day-label-week"><b>{{ weekday_label(wd) }} {{ fmt_day(wd) }}</b></span>
                        <div class="orders-container" *ngIf="!('load-shelf' | inProgress)">
                            <ng-container *ngFor="let event of (eventsForDate | fn : wd : refreshCount)">
                                <ng-container *ngTemplateOutlet="chipTpl; context: { $implicit: event }"></ng-container>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        }
        @case ('day') {
            <div class="date-grid shelf-day counter">
                <div class="day this-month" [class.today]="is_today_date(view_date)">
                    <span class="day-label-day"><b>{{ day_label() }}</b></span>
                    <div class="orders-container" *ngIf="!('load-shelf' | inProgress)">
                        <ng-container *ngFor="let event of (eventsForDate | fn : view_date : refreshCount)">
                            <ng-container *ngTemplateOutlet="chipTpl; context: { $implicit: event }"></ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        }
        @default {
            <div class="date-grid counter">
                <ng-container>
                    <th *ngFor="let day of days">{{ day[0] }}</th>
                </ng-container>
                <ng-container *ngFor="let week of (0 | upto: 5)">
                    <ng-container *ngFor="let day of days; let dayNum = index">
                        <ng-container *ngVar="week*7+dayNum-startDay as monthDay">
                            <div class="day"
                                *ngVar="(dayEvents | fn : monthDay : refreshCount) as getDayEvents"
                                [class.this-month]="isThisMonth(monthDay)"
                                [class.today]="isToday(monthDay)">

                                <span class="day-label-month">
                                    <b>{{ getDayLabel(monthDay) }}</b>
                                </span>

                                <div class="orders-container" *ngIf="!('load-shelf' | inProgress)">
                                    <ng-container *ngFor="let event of getDayEvents">
                                        <ng-container *ngTemplateOutlet="chipTpl; context: { $implicit: event }"></ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        }
    }

    <ng-template #chipTpl let-event>
        <a class="flex-row day-order" style="cursor: pointer;"
            [ngStyle]="{ borderLeft: '6px solid ' + status_color(event.status_id) }"
            (click)="open_chip(event.chip)">
            <i [attr.icon]="status_icon(event.status_id)"
                [ngStyle]="{ marginRight: '1em', color: status_color(event.status_id) }"></i>
            <span class="flex-column align-flex-start flex-dynamic">
                <span class="shelf-id" style="opacity: .5; font-size: 85%;">#{{ event.shelf_visit_id }}</span>
                <span class="flex-row align-flex-start" style="flex-wrap: wrap;">
                    @if (event.time) { <b>{{ event.time }}</b>&nbsp; }
                    <i>{{ type_short(event.work_type_ids) }}</i>
                    @if (event.is_ad_hoc) { &nbsp;<span class="adh-pill">{{ 'PUNJENJE.ADH' | trans }}</span> }
                </span>
                <strong>{{ event.location_name }}</strong>
                @if (event.location_cin) {
                    <span class="shelf-cin">{{ 'PUNJENJE.CARD.CIN' | trans }} {{ event.location_cin }}</span>
                }
                @if (event.supplier_name) {
                    <span class="shelf-supplier">{{ event.supplier_name }}</span>
                }
                @if (event.check_in || event.workers) {
                    <span class="shelf-visit-info flex-row align-center">
                        @if (event.check_in) {
                            <span class="vi-item"><i icon="schedule"></i>{{ event.check_in | datefmt : 'time' : false }}@if (event.check_out) {–{{ event.check_out | datefmt : 'time' : false }}}</span>
                        }
                        @if (event.workers) {
                            <span class="vi-item"><i icon="group"></i>{{ event.workers }}</span>
                        }
                    </span>
                }
            </span>
        </a>
    </ng-template>
</div>
